/**
 * Check if Google Analytics is active
 *
 * @returns {boolean} true if Google Analytics is active
 */
function isActive() {
  return !!(typeof window !== 'undefined' && typeof window.ga === 'function');
}

/**
 * Track page view
 *
 * @param {Object} options values to track
 * @returns {Promise<Object>} execution result
 */
function trackPageView(options = {}) {
  const { attributes = {} } = options;
  try {
    window.ga('send', 'pageview', attributes.page);
    return Promise.resolve({ done: true });
  } catch (err) {
    return Promise.reject(
      new Error(`Google Analytics: Could not execute ga(). Got error: ${err}.`)
    );
  }
}

module.exports = { isActive, trackPageView };
